import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { HelpCircle } from "lucide-react";
import api from '../../service/api';
import '../../css/style.css';
import '../../css/ParQ.css';

const PERGUNTAS_PARQ = [
    { id: 0, texto: "1. Algum médico já disse que você tem problema no coração e que só deve fazer atividade física com supervisão profissional?", tipo: "radio" },
    { id: 1, texto: "2. Você sente dores no peito quando pratica atividade física?", tipo: "radio" },
    { id: 2, texto: "3. No último mês, você sentiu dor no peito ao praticar atividade física?", tipo: "radio" },
    { id: 3, texto: "4. Você apresenta desequilíbrio devido à tontura e/ ou perda de consciência?", tipo: "radio" },
    { id: 4, texto: "5. Você possui algum problema ósseo ou articular que poderia ser piorado pela atividade física?", tipo: "radio" },
    { id: 5, texto: "6. Você toma atualmente algum medicamento para pressão arterial e/ou problema de coração?", tipo: "radio" },
    { id: 6, texto: "7. Sabe de alguma outra razão pela qual você não deve praticar atividade física?", tipo: "radio" }
];

const OPCOES_PARQ = [
    { id: 0, opcoes: ["Sim", "Não"] },
    { id: 1, opcoes: ["Sim", "Não"] },
    { id: 2, opcoes: ["Sim", "Não"] },
    { id: 3, opcoes: ["Sim", "Não"] },
    { id: 4, opcoes: ["Sim", "Não"] },
    { id: 5, opcoes: ["Sim", "Não"] },
    { id: 6, opcoes: ["Sim", "Não"] }
];

function ParQ({ setActiveTab, aluno, evaluationId, setEvaluationId, evaluationData, updateEvaluationData }) {
    const [etapa, setEtapa] = useState(1);
    const [isNextModal, setIsNextModal] = useState(false);
    const [isResponsabilidadeModal, setIsResponsabilidadeModal] = useState(false);
    const [responsabilidade, setResponsabilidade] = useState("-");
    const totalEtapas = 1;
    const porcentagemConclusao = (etapa / totalEtapas) * 100;

    // Popup de informações
    const [showInfo, setShowInfo] = useState(false);

    const avancarEtapa = () => {
        setEtapa(etapa + 1);
    };

    const retrocederEtapa = () => {
        if (etapa > 1) {
            setEtapa(etapa - 1);
        }
    };

    const openNextModal = () => setIsNextModal(true);
    const closeNextModal = () => setIsNextModal(false);
    const openResponsabilidadeModal = () => setIsResponsabilidadeModal(true);
    const closeResponsabilidadeModal = () => setIsResponsabilidadeModal(false);

    const handleResponsabilidade = () => {
        setResponsabilidade("Sim");
        closeResponsabilidadeModal();
        handleParQRegister();
    };

    const [respostasSelecionadas, setRespostasSelecionadas] = useState(evaluationData?.parQ?.respostas ||
        PERGUNTAS_PARQ.map(p => ({ id: p.id, valor: "" }))
    );

    useEffect(() => {
        if (evaluationData?.parQ?.respostas) {
            setRespostasSelecionadas(evaluationData.parQ.respostas);
        }
        if (evaluationData?.parQ?.responsabilidade) {
            setResponsabilidade(evaluationData.parQ.responsabilidade);
        }
    }, [evaluationData]);

    // Atualização focada em encontrar o objeto pelo ID
    const atualizarResposta = (perguntaId, novoValor) => {
        setRespostasSelecionadas(prev => prev.map(item =>
            item.id === perguntaId ? { ...item, valor: novoValor } : item
        ));
    };

    // Verificação adaptada para ler a propriedade .valor
    const handleParQRegister = async () => {
        const payload = {
            parQ: {
                respostas: respostasSelecionadas,
                responsabilidade
            },
            evaluationId
        };

        try {
            const response = await api.post(`/api/student/${aluno.id}/evaluation/parq`, payload, { withCredentials: true });
            if (response.status === 200) {
                if (response.data.evaluationId && setEvaluationId) {
                    if (!evaluationId) {
                        if (!aluno.avaliacoesRealizadas) aluno.avaliacoesRealizadas = [];
                        aluno.avaliacoesRealizadas.push({
                            id: response.data.evaluationId,
                            data: new Date().toISOString()
                        });
                    }
                    setEvaluationId(response.data.evaluationId);
                }
                if (updateEvaluationData) {
                    updateEvaluationData({ parQ: payload.parQ });
                }
                openNextModal();
            }
        } catch (error) {
            console.error('Erro ao salvar ParQ:', error);
        }
    };

    const verificarRespostas = () => {
        const algumaRespostaSim = respostasSelecionadas.some(r => r.valor === "Sim");

        if (responsabilidade !== "Sim" && algumaRespostaSim) {
            openResponsabilidadeModal();
        } else {
            handleParQRegister();
        }
    };

    const renderPerguntaParq = (pergunta) => {
        const rObj = respostasSelecionadas.find(item => item.id === pergunta.id);
        const valorAtual = rObj ? rObj.valor : "";

        const opcoesDaPergunta = OPCOES_PARQ.find(opt => opt.id === pergunta.id)?.opcoes || [];

        return (
            <div className="question-item" key={pergunta.id}>
                <div className="standard-title">{pergunta.texto}</div>
                <div className="answer-container">
                    {opcoesDaPergunta.map(opcao => (
                        <label className="answer-item" key={opcao}>
                            <input
                                type="radio" // PARQ é sempre radio
                                className="answer-radio"
                                checked={valorAtual === opcao}
                                onChange={() => atualizarResposta(pergunta.id, opcao)}
                            />
                            <p className="answer-title">{opcao}</p>
                        </label>
                    ))}
                </div>
            </div>
        );
    };

    // Divisão em colunas (4 na esquerda, 3 na direita)
    const meio = Math.ceil(PERGUNTAS_PARQ.length / 2);
    const perguntasEsquerda = PERGUNTAS_PARQ.slice(0, meio);
    const perguntasDireita = PERGUNTAS_PARQ.slice(meio);

    // Navegação provisória
    const toCoronariano = () => {
        setActiveTab("Coronariano");
    };

    return (
        <div className="avaliacao-container">
            <div className="avaliacao-content">
                <div className="questions-container">
                    <div className="questions-left">
                        {perguntasEsquerda.map(renderPerguntaParq)}
                    </div>
                    <div className="questions-right">
                        {perguntasDireita.map(renderPerguntaParq)}
                    </div>
                </div>

                <Modal
                    isOpen={isNextModal}
                    onRequestClose={closeNextModal}
                    contentLabel="Confirmacao"
                    className="modal-next"
                    overlayClassName="popup-overlay"
                >
                    <p className="popupNext-h1">ParQ finalizado!</p>
                    <p className="popupNext-h2">Deseja ir para o Risco Coronariano?</p>
                    <div>
                        <button className="next-prev-button" type="button" onClick={toCoronariano}>
                            Sim
                        </button>
                        <button className="next-prev-button" type="button" onClick={closeNextModal}>
                            Não
                        </button>
                    </div>
                </Modal>

                <Modal
                    isOpen={isResponsabilidadeModal}
                    onRequestClose={closeResponsabilidadeModal}
                    contentLabel="Confirmacao"
                    className="modal-responsabilidade"
                    overlayClassName="popup-overlay"
                >
                    <p className="popupNext-h1">Termo de Responsabilidade para Prática de Atividade Física </p>
                    <p className="popupNext-h2 pad-top-10">
                        Estou ciente de que é recomendável conversar com um médico antes de aumentar meu nível atual de atividade física, por ter respondido
                        “SIM” a uma ou mais perguntas do “Questionário de Prontidão para Atividade Física” (PAR-Q). Assumo plena responsabilidade por
                        qualquer atividade física praticada sem o atendimento a essa recomendação.
                    </p>
                    <div>
                        <button className="next-prev-button" type="button" onClick={handleResponsabilidade}>
                            Estou ciente e concordo com o termo de responsabilidade
                        </button>
                    </div>
                </Modal>

                <div className="pagination-footer">
                    <div className="sub-pagination-footer">
                        <div className="sub-pagination-buttons">
                            {etapa > 0 && (
                                <button className="next-prev-button" type="button" onClick={retrocederEtapa}>
                                    Voltar
                                </button>
                            )}
                            {etapa < 1 ? (
                                <button className="next-prev-button" type="button" onClick={avancarEtapa}>
                                    Avançar
                                </button>
                            ) : (
                                <button className="next-prev-button" type="button" onClick={verificarRespostas}> {/* Ajustado aqui */}
                                    Registrar
                                </button>
                            )}
                        </div>
                        <div className="progress-container">
                            <div className="progress-bar" style={{ width: `${porcentagemConclusao}%` }}></div>
                        </div>
                    </div>
                    <div className="info-box-container"  onMouseEnter={() => setShowInfo(true)} onMouseLeave={() => setShowInfo(false)}>
                        <div className="info-button">
                            <HelpCircle size={20} />
                            Mais informações
                        </div>
                        {showInfo && (
                            <div className="info-box-content">
                                <p className="">
                                    O PAR-Q (Physical Activity Readiness Questionnaire) é um questionário de triagem pré-participação utilizado para identificar, de forma rápida e segura, possíveis condições de saúde que possam exigir atenção antes do início ou intensificação da prática de exercícios físicos.
                                    <br/><br/>
                                    Por meio de perguntas objetivas relacionadas a sintomas, histórico cardiovascular, dores, limitações físicas e condições médicas, o PAR-Q auxilia na identificação de riscos potenciais e na necessidade de avaliação médica complementar.
                                    <br/><br/>
                                    Sua aplicação contribui para uma prescrição de exercícios mais segura, individualizada e alinhada às condições de saúde do avaliado.
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );

}

export default ParQ;
